import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { NodeType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const WEBPAGE: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  information: {
    definiteArticle: false,
    single: 'Zill-Web Pagina',
    plural: "Zill-Web Pagina's",
    icon: require('../../../../img/icons/webpage.svg'),
  },
  createModal: {
    authors: {
      addUser: true,
    },
  },
  websiteHref: null,
  buildingBlocks: [
    { type: NodeType.SECTION },
    { type: NodeType.PARAGRAPH },
    { type: NodeType.WORD_IMPORT },
  ],
  tocTypes: [NodeType.SECTION],
  edit: [titleComponent, descriptionComponent, publishComponent, authorsComponent],
  allowSuggestions: false,
  isCreatable: true,
  isSearchable: true,
};

export default WEBPAGE;
